import React from "react";
import TlkTable from "../../tlelrik/table/tlkTable";
import services from "../../../services";
import queryString from "query-string";
import moment from "moment";

const groupfield = [

    // { field: "Ano" },
    // { field: "Mês" },
    // { field: "Tipo de Movimento" },
    //{ field: "Entreposto" },
    // { field: 'Concelho' },
    // { field: 'Freguesia' },
];

const columnKeyMap = {
    ano: "Ano",
    mes: "Mês",
    dataOperacao: "Data da Operação",
    tipoContaDesc: "Tipo de Movimento",
    operacao: "Operação",
    valorOperacaoCapacidadeVenda: "Quantidade (Litros)",
    acumuladoDisponivel: "Saldo Acumulado Disponível",
};
const dateFormat = "DD-MM-YYYY HH:mm:ss";
const actionbuttons = { };

const filterValue = {
    Concelho: null,
    DataCriadoEnd: null,
    DataCriadoStart: null,
    DataModificadoEnd: null,
    DataModificadoStart: null,
    Designacao: null,
    Distrito: null,
    Estado: null,
    Fregusia: null,
    Geocod: null,
    NomeEntreposto: null,
    NumInstalacao: null,
    TipoInstalacao: null,
    nome: null,
    numero: null,
    entityId: null,
};

class CapVendaTab extends React.Component {
    constructor() {
        super();

        this.state = {
            loaded: false,
            data: [],
            totalCount: 0,
            currCapVenda: 0,
            columnList: [],
            filters: {
                Filters: filterValue,
                FiltersIn: null,
                FiltersLike: null,
                SortBy: "",
                IsSortTypeDESC: true,
                IsPagination: false,
                Page: 2,
                PageSize: 2,
            },
        };
    }

    componentDidMount() {
        (async () => {
            const queryParams = queryString.parse(this.props.location.search);
            const filters = {
                ...this.state.filters,
                Filters: {
                    ...this.state.filters.Filters,
                    NumInstalacao: queryParams.nif,
                    entityId: queryParams.entityId
                },
            };
            this.setState({
                nif: queryParams.nif,
            });
            const response = await services.apiCall.requestApi(
                "ContaCorrente/GetCapVendaEntidade",
                filters,
                "post"
            );
            // const columnList = Object.keys(columnKeyMap).map((key) => ({
            //     field: columnKeyMap[key],
            //     columnMenuType: "checkbox",
            // }));

            var columnList = [];

            Object.keys(columnKeyMap).forEach(e => {
                if(e === "ano" || e === "valorOperacaoCapacidadeVenda" || e === "acumuladoDisponivel"){
                    columnList.push({field: columnKeyMap[e], columnMenuType: "number"});
                }
                else{
                    columnList.push({field: columnKeyMap[e], columnMenuType: "checkbox"});
                }
            });

            if (response) {
                this.setState(() => ({
                    currCapVenda: response.length > 0 ? response[0].acumuladoDisponivel : null
                }));
                const data = response.map((entity, index) => ({
                    ...entity,
                    ...Object.keys(columnKeyMap).map((key) => {
                        if (
                            key === "valorOperacaoCapacidadeVenda" ||
                            key === "acumuladoDisponivel"
                        ) {
                            entity[columnKeyMap[key]] = services.money.format(entity[key]) || "0";
                        }
                        else if (key === "dataOperacao"){
                            entity[columnKeyMap[key]] = moment(
                                entity.dataOperacao
                            ).format(dateFormat)
                        }
                        else {
                            entity[columnKeyMap[key]] = entity[key] || "NA";
                        }
                    }),
                    selected: false,
                }));
                this.setState(() => ({
                    data,
                    columnList,
                    totalCount: window.localStorage.getItem("table_total"),
                    loaded: true,
                }));
            } else {
                this.setState(() => ({
                    data: response,
                    totalCount: 0,
                    columnList,
                    loaded: false,
                }));
            }
        })();
    }

    selectionChange(selection) {
        const data = [...this.state.data].map((item) => {
            if (
                selection.dataItem.codInstalacaoVinica ===
                item.codInstalacaoVinica
            ) {
                // TODO: Ask @Dart for the unique key to use here
                return { ...item, selected: true };
            } else {
                return { ...item, selected: false };
            }
        });
        this.setState({ data }, async () => {
            const queryParams = queryString.stringify({
                ...queryString.parse(this.props.location.search),
                installationId: 0,
            });
            this.props.history.push(
                `/conta_corrente/accounts_view?${queryParams}`
            );
        });
    }

    ActionPerform = async (action, row) => {
        if (action === "Detalhes da Conta") {
            const queryParams = queryString.stringify({
                entityId: row.codEntidade,
                IDInstalacaoVinica: row.idInstalacaoVinica,
                nif: this.state.nif,
            });
            this.props.history.push(
                `/conta_corrente/tabs_view/account?${queryParams}`
            );
        }
    };

    render() {
        return (
            <>
                {
                    <>
                        <span>
                            A pesquisa retornou {this.state.totalCount} registos
                        </span>
                        <TlkTable
                            date={new Date()}
                            list={this.state.data}
                            modulename={"Conta Corrente"}
                            groupfield={groupfield}
                            actionbuttons={actionbuttons}
                            columnlist={this.state.columnList}
                            // ActionPerform={(action, id) =>
                            //     this.ActionPerform(action, id)
                            // }
                            toolbarHTML={"Capacidade de Venda da entidade - " + services.money.format(this.state.currCapVenda) + " Litros"}
                        />
                    </>
                }
            </>
        );
    }
}

export default CapVendaTab;
